import React from 'react';
import { Award, Calendar, Globe, Shield, Target, Users } from 'lucide-react';
import AnimatedCounter from './enhanced/AnimatedCounter';

const OfficialFigures: React.FC = () => {
  return (
    <div className="official-figures" aria-label="Cifras institucionales">
      <div className="official-figures__cell">
        <Award size={18} aria-hidden="true" />
        <p className="official-figures__value">+3 años</p>
        <p className="official-figures__label">de experiencia</p>
      </div>
      <div className="official-figures__cell">
        <Shield size={18} aria-hidden="true" />
        <p className="official-figures__value">Reconocimiento</p>
        <p className="official-figures__label">del Congreso</p>
      </div>
      <div className="official-figures__cell">
        <AnimatedCounter
          value={10.6}
          prefix="+"
          suffix="k"
          decimals={1}
          label="comunidad digital"
          icon={<Users size={18} />}
        />
      </div>
      <div className="official-figures__cell">
        <AnimatedCounter
          value={300}
          prefix="+"
          label="jóvenes formados"
          icon={<Target size={18} />}
        />
      </div>
      <div className="official-figures__cell">
        <AnimatedCounter
          value={8}
          label="eventos nacionales realizados"
          icon={<Calendar size={18} />}
        />
      </div>
      <div className="official-figures__cell">
        <AnimatedCounter
          value={1}
          label="foro internacional"
          icon={<Globe size={18} />}
        />
      </div>
    </div>
  );
};

export default OfficialFigures;
